"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateX25519KeyPairFromSignature = exports.generateKeyFromSignature = exports.SignWalletWithKey = exports.singleUsePublicString = exports.newNonce = void 0;
const base64 = __importStar(require("@stablelib/base64"));
const utf8 = __importStar(require("@stablelib/utf8"));
const crypto = __importStar(require("crypto"));
const ed2curve_esm_1 = require("ed2curve-esm");
const tweetnacl_1 = require("tweetnacl");
const PUBLIC_STRING_LENGTH = 32;
const newNonce = () => (0, tweetnacl_1.randomBytes)(tweetnacl_1.secretbox.nonceLength);
exports.newNonce = newNonce;
// Generate a string that will seed the "lexi magic". This is assumed to be public knowledge.
exports.singleUsePublicString = base64.encode((0, tweetnacl_1.randomBytes)(PUBLIC_STRING_LENGTH));
const SHA256D = async (input) => {
    const first = crypto.createHash("sha256");
    const second = crypto.createHash("sha256");
    first.update(input);
    second.update(first.digest());
    return second.digest();
};
class SignWalletWithKey {
    constructor(signKey) {
        this.signKey = signKey;
    }
    async signMessage(message) {
        return tweetnacl_1.sign.detached(message, this.signKey.secretKey);
    }
}
exports.SignWalletWithKey = SignWalletWithKey;
/**
 * The "lexi magic":
 * Sign and hash a non-secret public string with an asymmetric secret key, creating the secret for the encryption key
 * @param signer
 * @param publicString
 */
const generateKeyFromSignature = async (signer, publicString) => {
    // first we blind the 'publicString' by hashing to ensure we're not
    // signing arbitrary attacker-provided data:
    // base64 encode the message because the raw bytes look a bit weird to users of Civic.me
    const signatureInput = utf8.encode(base64.encode(await SHA256D(utf8.encode(publicString))));
    const signature = await signer.signMessage(signatureInput);
    // Hash the signature to standardise it to 32 bytes
    // using tweetnacl for hashing creates a 64 byte hash, so we use the native crypto lib here instead
    // return hash(secret);
    return SHA256D(signature);
};
exports.generateKeyFromSignature = generateKeyFromSignature;
const generateX25519KeyPairFromSignature = async (signer, publicString, encryptionKeyBox) => {
    if (encryptionKeyBox.encryptionKey === null) {
        const key = await (0, exports.generateKeyFromSignature)(signer, publicString);
        const ed25519Keypair = tweetnacl_1.sign.keyPair.fromSeed(key);
        encryptionKeyBox.encryptionKey = (0, ed2curve_esm_1.convertKeyPair)(ed25519Keypair);
    }
    return encryptionKeyBox.encryptionKey;
};
exports.generateX25519KeyPairFromSignature = generateX25519KeyPairFromSignature;
